import FormattedText from './FormattedText';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { MdSettings } from 'react-icons/md';
import '../portal.css';

export default function PortalModal({
  title,
  description,
  icon,
  busy = false,
  onClose,
  children,
  size = 'lg',
  id = 'portal-modal-title',
}) {
  return (
    <Modal
      show
      centered
      size={size}
      className="portal-admin portal-modal"
      dialogClassName="portal-modal-dialog"
      aria-labelledby={id}
      backdrop={busy ? 'static' : true}
      backdropClassName="hidethis"
      keyboard={!busy}
      onHide={() => !busy && onClose()}
    >
      <Modal.Header closeButton={!busy} closeLabel="Fechar modal">
        <div className="portal-modal-heading">
          <span className="portal-modal-icon" aria-hidden="true">
            {icon || <MdSettings />}
          </span>
          <div>
            <Modal.Title id={id}><FormattedText>{title}</FormattedText></Modal.Title>
            {description && <p><FormattedText>{description}</FormattedText></p>}
          </div>
        </div>
      </Modal.Header>
      {children}
    </Modal>
  );
}
